<template>
  <div class="order-container">
    <el-empty v-if="!hockMaterialList || hockMaterialList.length === 0" description="暂无数据"/>
    <div class="order-info" v-else>
      <order-material :materials="hockMaterialList" :model="3"/>
    </div>
  </div>
</template>

<script>

import OrderMaterial from "@/views/order/info/componet/OrderMaterial.vue";

export default {
  name: "HockTab",
  components: {OrderMaterial},
  props: {
    hockMaterialList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeTab: 'executionPlan'
    };
  }
};
</script>

<style scoped>
</style>
